import { useCallback } from 'react'
import { useFormikContext } from 'formik'

import l10n from '../../i18n/I18N'
import { formatCurrencyAmountFromConfig, getCryptoCurrencyConfigForCryptoId, getWallet, getThemeImageUrl } from '../../../services/utils'
import { config } from '../../Init/Init'
import { CryptoPaymentDepositCurrencyIcon } from '../CryptoPaymentDeposit/CryptoPaymentDepositCurrencyIcon'
import { formFieldPlaceholders, withdrawFormFields, withdrawalSteps } from '../cryptoPaymentConstants'
import { useCryptoPaymentDataModal } from '../CryptoPaymentModalDataProvider'

import classes from './styles/cryptoPaymentWithdrawalFormInfo.module.scss'

export const CryptoPaymentWithdrawalFormInfoTop = ({ playerWallets, currencyConfig }) => {
  return (
    <div className={`${classes.cryptoPaymentWithdrawalForm__redeemableCoins} formElement`}>
      <div>
        <img
          src={getThemeImageUrl(classes.cryptoPaymentSweepsIcon)}
          alt={l10n.t['currency.SC']}
          className={classes.cryptoPaymentWithdrawalForm__coinIcon}
        />
        &nbsp;
        {l10n.t['cryptopayment.deposit.redeemableCoins']}
      </div>
      <div className={classes.cryptoPaymentWithdrawalForm__redeemableCoinsAmount}>
        {currencyConfig.currencyName}
        &nbsp;
        {formatCurrencyAmountFromConfig(getWallet(playerWallets, config.swtWalletId), currencyConfig)}
      </div>
    </div>
  )
}

export const CryptoPaymentWithdrawalFormInfoBottom = ({ currencyConfig }) => {
  const { withdrawalStep, selectedCurrency, withdrawalDraftData } = useCryptoPaymentDataModal()

  const { values } = useFormikContext()

  const getNetworkFeeAmount = useCallback(() => {
    if (withdrawalStep === withdrawalSteps.create) {
      return formFieldPlaceholders.crypto
    }

    const cryptoCurrencyConfigs = getCryptoCurrencyConfigForCryptoId(values[withdrawFormFields.currency])

    const { currency, amount } = withdrawalDraftData.networkFeeCurrency
    const { rate } = withdrawalDraftData.exchangeRate

    // for now client receive fee in USD. in that case we need convert USD to cryptoCurrency to show amount to user
    if (currency === config.baseFiatCurrency) {
      return formatCurrencyAmountFromConfig(rate * amount, cryptoCurrencyConfigs)
    } else {
      return formatCurrencyAmountFromConfig(amount, cryptoCurrencyConfigs)
    }
  }, [values, withdrawalDraftData.exchangeRate, withdrawalDraftData.networkFeeCurrency, withdrawalStep])

  return (
    <div className={classes.cryptoPaymentWithdrawalForm__info}>
      <div className={classes.cryptoPaymentWithdrawalForm__infoItem}>
        • {l10n.t['cryptopayment.redeem.minimumRedeem']}&nbsp;
        <img
          src={getThemeImageUrl(classes.cryptoPaymentSweepsIcon)}
          alt={l10n.t['currency.SC']}
          className={classes.cryptoPaymentWithdrawalForm__coinIcon}
        />
        &nbsp;
        {currencyConfig.currencyName}
        &nbsp;
        {formatCurrencyAmountFromConfig(config.cryptoWithdrawalMinUSD, currencyConfig)}
      </div>
      <div className={classes.cryptoPaymentWithdrawalForm__infoItem}>
        • {l10n.t['cryptopayment.redeem.transactionFee']}&nbsp;
        <CryptoPaymentDepositCurrencyIcon
          width={classes.cryptoIconSize}
          height={classes.cryptoIconSize}
          currencyCode={selectedCurrency.currencyCode}
        />
        &nbsp;{getNetworkFeeAmount()} {selectedCurrency.currencyCode}
      </div>
    </div>
  )
}
